// import {
//   Component,
//   OnDestroy,
//   OnInit
// } from '@angular/core';

// import {
//   CommonModule,
//   DatePipe
// } from '@angular/common';

// import { FormsModule } from '@angular/forms';
// import { interval, Subscription } from 'rxjs';

// import { ApiService } from '../../core/api.service';
// import { SocketService } from '../../core/socket.service';

// @Component({
//   selector: 'app-orders',
//   standalone: true,
//   imports: [
//     CommonModule,
//     FormsModule,
//     DatePipe
//   ],
//   templateUrl: './orders.component.html',
//   styleUrl: './orders.component.css'
// })
// export class OrdersComponent
//   implements OnInit, OnDestroy {

//   restaurants: any[] = [];
//   restaurantId: any = '';
//   orders: any[] = [];

//   sub?: Subscription;

//   loading = false;
//   soundEnabled = false;
//   lastOrderId?: number;

//   updatingOrderIds = new Set<number>();

//   statuses = [
//     'PENDING',
//     'ACCEPTED',
//     'PREPARING',
//     'READY',
//     'OUT_FOR_DELIVERY',
//     'DELIVERED',
//     'CANCELED'
//   ];

//   constructor(
//     private api: ApiService,
//     private socket: SocketService
//   ) {}

//   ngOnInit(): void {
//     this.loadRestaurants();
//   }

//   loadRestaurants(): void {
//     this.api
//       .get<any[]>('/restaurants')
//       .subscribe({
//         next: restaurants => {
//           this.restaurants = restaurants || [];

//           if (this.restaurants.length) {
//             this.restaurantId =
//               this.restaurants[0].id;

//             this.loadOrders();
//             this.startRealtimeFallback();
//           }
//         },
//         error: error => {
//           console.error(
//             'Erro ao carregar restaurantes:',
//             error
//           );
//         }
//       });
//   }

//   loadOrders(playSound = false): void {
//     if (!this.restaurantId) {
//       return;
//     }

//     this.loading = true;

//     this.api
//       .get<any[]>(
//         `/orders?restaurantId=${this.restaurantId}`
//       )
//       .subscribe({
//         next: orders => {
//           const loadedOrders = orders || [];

//           const newestOrderId = Number(
//             loadedOrders[0]?.id || 0
//           );

//           if (
//             playSound &&
//             this.lastOrderId &&
//             newestOrderId &&
//             newestOrderId > this.lastOrderId
//           ) {
//             this.notify();
//           }

//           this.lastOrderId =
//             newestOrderId || undefined;

//           this.orders = loadedOrders;
//           this.loading = false;
//         },
//         error: error => {
//           this.loading = false;

//           console.error(
//             'Erro ao carregar pedidos:',
//             error
//           );
//         }
//       });
//   }

//   startRealtimeFallback(): void {
//     this.sub?.unsubscribe();

//     this.sub = interval(8000).subscribe(() => {
//       this.loadOrders(true);
//     });
//   }

//   onRestaurantChange(): void {
//     this.orders = [];
//     this.lastOrderId = undefined;

//     this.loadOrders();
//     this.startRealtimeFallback();
//   }

//   updateStatus(
//     order: any,
//     status: string
//   ): void {
//     const orderId = Number(order?.id);

//     if (!orderId) {
//       alert('Pedido inválido.');
//       return;
//     }

//     if (!status) {
//       alert('Status inválido.');
//       return;
//     }

//     if (this.updatingOrderIds.has(orderId)) {
//       return;
//     }

//     if (order.status === status) {
//       return;
//     }

//     const previousStatus = order.status;

//     order.status = status;
//     this.updatingOrderIds.add(orderId);

//     this.api
//       .patch<any>(
//         `/orders/${orderId}/status`,
//         { status }
//       )
//       .subscribe({
//         next: updatedOrder => {
//           order.status =
//             updatedOrder?.status || status;

//           this.updatingOrderIds.delete(orderId);

//           if (status === 'DELIVERED') {
//             this.loadOrders();
//           }
//         },
//         error: error => {
//           order.status = previousStatus;
//           this.updatingOrderIds.delete(orderId);

//           console.error(
//             'Erro ao atualizar status:',
//             error
//           );

//           alert(
//             error?.error?.message ||
//             'Erro ao atualizar o status do pedido.'
//           );
//         }
//       });
//   }

//   isUpdating(order: any): boolean {
//     return this.updatingOrderIds.has(
//       Number(order?.id)
//     );
//   }

//   enableSound(): void {
//     this.soundEnabled = !this.soundEnabled;

//     if (this.soundEnabled) {
//       this.notify();
//     }
//   }

//   notify(): void {
//     if (!this.soundEnabled) {
//       return;
//     }

//     const audio = new Audio(
//       'data:audio/wav;base64,' +
//       'UklGRiQAAABXQVZFZm10IBAAAAABAAEA' +
//       'ESsAACJWAAACABAAZGF0YQAAAAA='
//     );

//     audio.play().catch(() => {});
//   }

//   formatMoney(value: any): string {
//     const numericValue = Number(value || 0);

//     return new Intl.NumberFormat('pt-BR', {
//       style: 'currency',
//       currency: 'BRL'
//     }).format(numericValue);
//   }

//   statusLabel(status: string): string {
//     const labels: Record<string, string> = {
//       PENDING: 'Pendente',
//       ACCEPTED: 'Aceito',
//       PREPARING: 'Em preparo',
//       READY: 'Pronto',
//       OUT_FOR_DELIVERY: 'Saiu para entrega',
//       DELIVERED: 'Entregue',
//       CANCELED: 'Cancelado'
//     };

//     return labels[status] || status;
//   }

//   deliveryTypeLabel(
//     deliveryType: string
//   ): string {
//     const labels: Record<string, string> = {
//       DELIVERY: 'Entrega',
//       PICKUP: 'Retirada',
//       TABLE: 'Mesa'
//     };

//     return labels[deliveryType] || deliveryType;
//   }

//   totalItems(order: any): number {
//     return (order.items || []).reduce(
//       (
//         total: number,
//         item: any
//       ) =>
//         total +
//         Number(item.quantity || 0),
//       0
//     );
//   }

//   trackByOrderId(
//     index: number,
//     order: any
//   ): number {
//     return order.id;
//   }

//   ngOnDestroy(): void {
//     this.sub?.unsubscribe();
//     this.socket.disconnect();
//   }
// }


import {
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';

import {
  CommonModule,
  DatePipe
} from '@angular/common';

import {
  FormsModule
} from '@angular/forms';

import {
  interval,
  Subscription
} from 'rxjs';

import {
  ApiService
} from '../../core/api.service';

import {
  SocketService
} from '../../core/socket.service';


type KanbanColumnKey =
  | 'WAITING'
  | 'PREPARING'
  | 'READY'
  | 'DELIVERY';


@Component({
  selector: 'app-orders',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule,
    DatePipe
  ],

  templateUrl:
    './orders.component.html',

  styleUrl:
    './orders.component.css'
})
export class OrdersComponent
  implements OnInit, OnDestroy {

  restaurants: any[] = [];

  restaurantId: any = '';

  orders: any[] = [];


  sub?: Subscription;


  loading = false;

  soundEnabled = false;

  lastOrderId?: number;

historyPage = 1;
historyPageSize = 10;
  updatingOrderIds =
    new Set<number>();


  /*
   * Pedido aberto para detalhes.
   */
  expandedOrderId:
    number | null = null;


  /*
   * ==============================
   * FILTROS
   * ==============================
   */

  searchOrderNumber = '';

  statusFilter = 'ACTIVE';

  deliveryTypeFilter = 'ALL';


  /*
   * ==============================
   * STATUS
   * ==============================
   */

  statuses = [
    'PENDING',
    'ACCEPTED',
    'PREPARING',
    'READY',
    'OUT_FOR_DELIVERY',
    'DELIVERED',
    'CANCELED'
  ];

get paginatedHistoryOrders(): any[] {

  const start =
    (this.historyPage - 1) *
    this.historyPageSize;

  const end =
    start + this.historyPageSize;

  return this.historyOrders.slice(
    start,
    end
  );
}


get historyTotalPages(): number {

  const total =
    Math.ceil(
      this.historyOrders.length /
      this.historyPageSize
    );

  return Math.max(total, 1);
}


get historyStartItem(): number {

  if (!this.historyOrders.length) {
    return 0;
  }

  return (
    (this.historyPage - 1) *
    this.historyPageSize
  ) + 1;
}


get historyEndItem(): number {

  return Math.min(
    this.historyPage *
      this.historyPageSize,
    this.historyOrders.length
  );
}


previousHistoryPage(): void {

  if (this.historyPage <= 1) {
    return;
  }

  this.historyPage--;
}


nextHistoryPage(): void {

  if (
    this.historyPage >=
    this.historyTotalPages
  ) {
    return;
  }

  this.historyPage++;
}


goToHistoryPage(
  page: number
): void {

  if (
    page < 1 ||
    page > this.historyTotalPages
  ) {
    return;
  }

  this.historyPage = page;
}


get historyPages(): number[] {

  const pages: number[] = [];

  for (
    let page = 1;
    page <= this.historyTotalPages;
    page++
  ) {
    pages.push(page);
  }

  return pages;
}
  /*
   * ==============================
   * COLUNAS
   * ==============================
   */

  columns = [
    {
      key: 'WAITING' as KanbanColumnKey,
      title: 'Aguardando',
      description: 'Novos pedidos',
      icon: '🟡'
    },

    {
      key: 'PREPARING' as KanbanColumnKey,
      title: 'Em preparo',
      description: 'Pedidos na cozinha',
      icon: '🟣'
    },

    {
      key: 'READY' as KanbanColumnKey,
      title: 'Prontos',
      description: 'Aguardando saída',
      icon: '🔵'
    },

    {
      key: 'DELIVERY' as KanbanColumnKey,
      title: 'Em entrega',
      description: 'Pedidos em rota',
      icon: '🟢'
    }
  ];


  constructor(
    private api:
      ApiService,

    private socket:
      SocketService
  ) {}


  ngOnInit(): void {
    this.loadRestaurants();
  }


  /*
   * ==============================
   * RESTAURANTES
   * ==============================
   */

  resetHistoryPage(): void {
  this.historyPage = 1;
}

  loadRestaurants(): void {

    this.api
      .get<any[]>(
        '/restaurants'
      )
      .subscribe({

        next:
          restaurants => {

            this.restaurants =
              restaurants || [];


            if (
              this.restaurants
                .length
            ) {

              this.restaurantId =
                this.restaurants[0]
                  .id;


              this.loadOrders();

              this.startRealtimeFallback();
            }
          },


        error:
          error => {

            console.error(
              'Erro ao carregar restaurantes:',
              error
            );
          }

      });
  }


  /*
   * ==============================
   * PEDIDOS
   * ==============================
   */

  loadOrders(
    playSound = false
  ): void {

    if (
      !this.restaurantId
    ) {
      return;
    }


    this.loading =
      true;


    this.api
      .get<any[]>(
        `/orders?restaurantId=${this.restaurantId}`
      )
      .subscribe({

        next:
          orders => {

            const loadedOrders =
              orders || [];


            const newestOrderId =
              Number(
                loadedOrders[0]
                  ?.id || 0
              );


            if (
              playSound &&
              this.lastOrderId &&
              newestOrderId &&
              newestOrderId >
                this.lastOrderId
            ) {
              this.notify();
            }


            this.lastOrderId =
              newestOrderId ||
              undefined;


            this.orders =
              loadedOrders;


            this.loading =
              false;
          },


        error:
          error => {

            this.loading =
              false;


            console.error(
              'Erro ao carregar pedidos:',
              error
            );
          }

      });
  }


  /*
   * ==============================
   * FALLBACK TEMPO REAL
   * ==============================
   */

  startRealtimeFallback(): void {

    this.sub
      ?.unsubscribe();


    this.sub =
      interval(
        8000
      )
        .subscribe(
          () => {

            this.loadOrders(
              true
            );

          }
        );
  }


  onRestaurantChange(): void {

    this.orders = [];

    this.lastOrderId =
      undefined;


    this.clearFilters();


    this.loadOrders();

    this.startRealtimeFallback();
  }


  /*
   * ==============================
   * FILTROS
   * ==============================
   */

  clearFilters(): void {

    this.searchOrderNumber =
      '';

    this.statusFilter =
      'ACTIVE';

    this.deliveryTypeFilter =
      'ALL';

        this.historyPage = 1;
  }


  get filteredOrders():
    any[] {

    let result =
      [...this.orders];


    /*
     * BUSCA POR NÚMERO
     */
    const search =
      String(
        this.searchOrderNumber ||
        ''
      )
        .replace(
          /\D/g,
          ''
        );


    if (search) {

      result =
        result.filter(
          order =>
            String(
              order.id
            )
              .includes(search)
        );
    }


    /*
     * STATUS
     */
    if (
      this.statusFilter ===
      'ACTIVE'
    ) {

      result =
        result.filter(
          order =>
            ![
              'DELIVERED',
              'CANCELED'
            ]
              .includes(
                order.status
              )
        );

    } else if (
      this.statusFilter !==
      'ALL'
    ) {

      result =
        result.filter(
          order =>
            order.status ===
            this.statusFilter
        );
    }


    /*
     * TIPO
     */
    if (
      this.deliveryTypeFilter !==
      'ALL'
    ) {

      result =
        result.filter(
          order =>
            order.deliveryType ===
            this.deliveryTypeFilter
        );
    }


    return result;
  }


  /*
   * ==============================
   * KANBAN
   * ==============================
   */

  ordersByColumn(
    column:
      KanbanColumnKey
  ): any[] {

    const orders =
      this.filteredOrders;


    switch (
      column
    ) {

      case 'WAITING':

        return orders
          .filter(
            order =>
              [
                'PENDING',
                'ACCEPTED'
              ]
                .includes(
                  order.status
                )
          );


      case 'PREPARING':

        return orders
          .filter(
            order =>
              order.status ===
              'PREPARING'
          );


      case 'READY':

        return orders
          .filter(
            order =>
              order.status ===
              'READY'
          );


      case 'DELIVERY':

        return orders
          .filter(
            order =>
              order.status ===
              'OUT_FOR_DELIVERY'
          );


      default:

        return [];
    }
  }


  columnCount(
    column:
      KanbanColumnKey
  ): number {

    return this
      .ordersByColumn(
        column
      )
      .length;
  }


  /*
   * ==============================
   * HISTÓRICO
   * ==============================
   */

  get historicalOrders():
    any[] {

    return this
      .filteredOrders
      .filter(
        order =>
          [
            'DELIVERED',
            'CANCELED'
          ]
            .includes(
              order.status
            )
      );
  }


  /*
   * ==============================
   * DETALHES
   * ==============================
   */

  toggleDetails(
    order: any
  ): void {

    const id =
      Number(
        order?.id
      );


    if (
      this.expandedOrderId ===
      id
    ) {

      this.expandedOrderId =
        null;

      return;
    }


    this.expandedOrderId =
      id;
  }


  isExpanded(
    order: any
  ): boolean {

    return (
      this.expandedOrderId ===
      Number(
        order?.id
      )
    );
  }


  /*
   * ==============================
   * PRÓXIMA AÇÃO
   * ==============================
   */

  nextStatus(
    order: any
  ): string | null {

    const map:
      Record<
        string,
        string
      > = {

        PENDING:
          'ACCEPTED',

        ACCEPTED:
          'PREPARING',

        PREPARING:
          'READY',

        READY:
          order.deliveryType ===
          'DELIVERY'
            ? 'OUT_FOR_DELIVERY'
            : 'DELIVERED',

        OUT_FOR_DELIVERY:
          'DELIVERED'
      };


    return (
      map[
        order.status
      ] || null
    );
  }


  nextStatusLabel(
    order: any
  ): string {

    const status =
      this.nextStatus(
        order
      );


    const labels:
      Record<
        string,
        string
      > = {

        ACCEPTED:
          'Aceitar pedido',

        PREPARING:
          'Iniciar preparo',

        READY:
          'Marcar como pronto',

        OUT_FOR_DELIVERY:
          'Saiu para entrega',

        DELIVERED:
          'Concluir pedido'
      };


    return (
      status
        ? labels[status]
        : ''
    );
  }


  advanceOrder(
    order: any
  ): void {

    const status =
      this.nextStatus(
        order
      );


    if (!status) {
      return;
    }


    this.updateStatus(
      order,
      status
    );
  }


  /*
   * ==============================
   * STATUS
   * ==============================
   */

  updateStatus(
    order: any,
    status: string
  ): void {

    const orderId =
      Number(
        order?.id
      );


    if (!orderId) {

      alert(
        'Pedido inválido.'
      );

      return;
    }


    if (!status) {

      alert(
        'Status inválido.'
      );

      return;
    }


    if (
      this.updatingOrderIds
        .has(
          orderId
        )
    ) {
      return;
    }


    if (
      order.status ===
      status
    ) {
      return;
    }


    const previousStatus =
      order.status;


    order.status =
      status;


    this.updatingOrderIds
      .add(
        orderId
      );


    this.api
      .patch<any>(
        `/orders/${orderId}/status`,
        {
          status
        }
      )
      .subscribe({

        next:
          updatedOrder => {

            order.status =
              updatedOrder
                ?.status ||
              status;


            this.updatingOrderIds
              .delete(
                orderId
              );


            if (
              [
                'DELIVERED',
                'CANCELED'
              ]
                .includes(
                  status
                )
            ) {

              this.loadOrders();
            }
          },


        error:
          error => {

            order.status =
              previousStatus;


            this.updatingOrderIds
              .delete(
                orderId
              );


            console.error(
              'Erro ao atualizar status:',
              error
            );


            alert(
              error
                ?.error
                ?.message ||
              'Erro ao atualizar o status do pedido.'
            );
          }

      });
  }


  isUpdating(
    order: any
  ): boolean {

    return this
      .updatingOrderIds
      .has(
        Number(
          order?.id
        )
      );
  }


  /*
   * ==============================
   * SOM
   * ==============================
   */

  enableSound(): void {

  this.soundEnabled =
    !this.soundEnabled;

  /*
   * O navegador exige uma interação
   * do usuário antes de permitir áudio.
   *
   * Esse teste também confirma
   * visualmente/sonoramente que o som
   * foi habilitado.
   */
  if (
    this.soundEnabled
  ) {
    this.notify();
  }
}





  get showingHistory(): boolean {

  return (
    this.statusFilter === 'DELIVERED' ||
    this.statusFilter === 'CANCELED'
  );
}


get historyOrders(): any[] {

  return this.filteredOrders
    .filter(
      order =>
        [
          'DELIVERED',
          'CANCELED'
        ].includes(
          order.status
        )
    );
}

notify(): void {

  if (
    !this.soundEnabled
  ) {
    return;
  }

  try {

    const AudioContextClass =
      window.AudioContext ||
      (window as any).webkitAudioContext;


    const audioContext =
      new AudioContextClass();


    /*
     * Primeiro bip
     */
    const oscillator1 =
      audioContext.createOscillator();

    const gain1 =
      audioContext.createGain();


    oscillator1.type =
      'sine';

    oscillator1.frequency
      .setValueAtTime(
        880,
        audioContext.currentTime
      );


    gain1.gain
      .setValueAtTime(
        0.22,
        audioContext.currentTime
      );


    gain1.gain
      .exponentialRampToValueAtTime(
        0.01,
        audioContext.currentTime +
        0.22
      );


    oscillator1.connect(
      gain1
    );

    gain1.connect(
      audioContext.destination
    );


    oscillator1.start();

    oscillator1.stop(
      audioContext.currentTime +
      0.22
    );


    /*
     * Segundo bip.
     *
     * Dá uma sensação de
     * "novo pedido recebido".
     */
    const oscillator2 =
      audioContext.createOscillator();

    const gain2 =
      audioContext.createGain();


    oscillator2.type =
      'sine';

    oscillator2.frequency
      .setValueAtTime(
        1175,
        audioContext.currentTime +
        0.25
      );


    gain2.gain
      .setValueAtTime(
        0.01,
        audioContext.currentTime
      );


    gain2.gain
      .setValueAtTime(
        0.24,
        audioContext.currentTime +
        0.25
      );


    gain2.gain
      .exponentialRampToValueAtTime(
        0.01,
        audioContext.currentTime +
        0.5
      );


    oscillator2.connect(
      gain2
    );

    gain2.connect(
      audioContext.destination
    );


    oscillator2.start(
      audioContext.currentTime +
      0.25
    );

    oscillator2.stop(
      audioContext.currentTime +
      0.5
    );


    /*
     * Fecha o contexto depois
     * de tocar.
     */
    setTimeout(
      () => {

        audioContext
          .close()
          .catch(
            () => {}
          );

      },
      700
    );

  } catch (error) {

    console.error(
      'Erro ao reproduzir som:',
      error
    );
  }
}

  /*
   * ==============================
   * TEMPO
   * ==============================
   */

  getMinutesSinceOrder(
    order: any
  ): number {

    if (
      !order?.createdAt
    ) {
      return 0;
    }


    const created =
      new Date(
        order.createdAt
      )
        .getTime();


    return Math.max(
      0,

      Math.floor(
        (
          Date.now() -
          created
        ) /
        60000
      )
    );
  }


  orderAgeLabel(
    order: any
  ): string {

    const minutes =
      this.getMinutesSinceOrder(
        order
      );


    if (
      minutes < 1
    ) {
      return 'Agora';
    }


    if (
      minutes < 60
    ) {
      return `há ${minutes} min`;
    }


    const hours =
      Math.floor(
        minutes / 60
      );


    const remainingMinutes =
      minutes % 60;


    if (
      remainingMinutes === 0
    ) {

      return `há ${hours}h`;
    }


    return (
      `há ${hours}h ${remainingMinutes}min`
    );
  }


  ageLevel(
    order: any
  ): string {

    const minutes =
      this.getMinutesSinceOrder(
        order
      );


    if (
      minutes >= 30
    ) {
      return 'critical';
    }


    if (
      minutes >= 20
    ) {
      return 'warning';
    }


    return 'normal';
  }
availableStatuses(order: any): string[] {

  const commonStatuses = [
    'PENDING',
    'ACCEPTED',
    'PREPARING',
    'READY'
  ];

  if (order.deliveryType === 'DELIVERY') {
    return [
      ...commonStatuses,
      'OUT_FOR_DELIVERY',
      'DELIVERED',
      'CANCELED'
    ];
  }

  return [
    ...commonStatuses,
    'DELIVERED',
    'CANCELED'
  ];
}


statusOptionLabel(status: string): string {

  const labels: Record<string, string> = {

    PENDING:
      '🟡 Pendente',

    ACCEPTED:
      '🟠 Aceito',

    PREPARING:
      '🟣 Em preparo',

    READY:
      '🔵 Pronto',

    OUT_FOR_DELIVERY:
      '🛵 Saiu para entrega',

    DELIVERED:
      '✅ Entregue',

    CANCELED:
      '❌ Cancelado'

  };

  return labels[status] || status;
}

  /*
   * ==============================
   * HELPERS
   * ==============================
   */

  formatMoney(
    value: any
  ): string {

    const numericValue =
      Number(
        value || 0
      );


    return new Intl
      .NumberFormat(
        'pt-BR',
        {
          style:
            'currency',

          currency:
            'BRL'
        }
      )
      .format(
        numericValue
      );
  }


  statusLabel(
    status: string
  ): string {

    const labels:
      Record<
        string,
        string
      > = {

        PENDING:
          'Pendente',

        ACCEPTED:
          'Aceito',

        PREPARING:
          'Em preparo',

        READY:
          'Pronto',

        OUT_FOR_DELIVERY:
          'Saiu para entrega',

        DELIVERED:
          'Entregue',

        CANCELED:
          'Cancelado'
      };


    return (
      labels[status] ||
      status
    );
  }


  deliveryTypeLabel(
    deliveryType: string
  ): string {

    const labels:
      Record<
        string,
        string
      > = {

        DELIVERY:
          'Entrega',

        PICKUP:
          'Retirada',

        TABLE:
          'Mesa'
      };


    return (
      labels[
        deliveryType
      ] ||
      deliveryType
    );
  }


  totalItems(
    order: any
  ): number {

    return (
      order.items ||
      []
    )
      .reduce(
        (
          total:
            number,

          item:
            any
        ) =>
          total +
          Number(
            item.quantity ||
            0
          ),

        0
      );
  }


  trackByOrderId(
    index:
      number,

    order:
      any
  ): number {

    return order.id;
  }


  ngOnDestroy(): void {

    this.sub
      ?.unsubscribe();


    this.socket
      .disconnect();
  }
}



